import { Typography, useTheme } from '@mui/material';

import {
  ListSubheaderIconWrapperStyled,
  ListSubheaderStyled,
} from './ListSubheaderStyled';

export interface ListSubheaderProps {
  title: string;
  icon?: JSX.Element;
}

export const ListSubheader = ({ title, icon }: ListSubheaderProps) => {
  const theme = useTheme();

  return (
    <ListSubheaderStyled data-testid="list-subheader">
      {icon && (
        <ListSubheaderIconWrapperStyled data-testid="list-subheader-icon">
          {icon}
        </ListSubheaderIconWrapperStyled>
      )}
      <Typography variant="body1Heading" ml={theme.spacing(4)}>
        {title}
      </Typography>
    </ListSubheaderStyled>
  );
};
